import { combineReducers } from "redux";
import walletConnection from '../reducers/walletConnection';
import network from './selectedNetwork';

export default combineReducers({
    walletConnection,network
});